import { exportToExcelWithXLSX } from "@perfectserve/library";
export const handleExecutiveSummaryExcelExport = async (accountSummaryData, viewSettings, kpiResult) => {
    const exportData = accountSummaryData.map((row) => {
        const rowData = {
            "Account/User": row.accountName,
        };
        if (viewSettings.showPractices) {
            rowData["Practices"] = Array.isArray(row.practices) ? row.practices.join(", ") : row.practices || "—";
        }
        if (viewSettings.showTotalInteractions) {
            rowData["Total Interactions"] = row.totalInteractions;
        }
        if (viewSettings.showUrgent) {
            rowData["Urgent"] = row.urgent;
        }
        if (viewSettings.showRoutine) {
            rowData["Routine"] = row.routine;
        }
        if (viewSettings.showAvgUrgentReadTime) {
            rowData["Avg Urgent Read Time"] = row.avgUrgentReadTime || "—";
        }
        if (viewSettings.showMedianUrgentReadTime) {
            rowData["Median Urgent Read Time"] = row.medianUrgentReadTime || "—";
        }
        if (viewSettings.showAvgCallbackTime) {
            rowData["Avg Callback Time"] = row.avgCallbackTime || "—";
        }
        if (viewSettings.showMedianCallbackTime) {
            rowData["Median Callback Time"] = row.medianCallbackTime || "—";
        }
        if (viewSettings.showAvgCallbackDuration) {
            rowData["Avg Callback Duration"] = row.avgCallbackDuration || "—";
        }
        if (viewSettings.showMedianCallbackDuration) {
            rowData["Median Callback Duration"] = row.medianCallbackDuration || "—";
        }
        if (viewSettings.showCallbackCount) {
            rowData["Callback Count"] = row.callbackCount;
        }
        if (viewSettings.showVoicemails) {
            rowData["Voicemails"] = row.voicemails;
        }
        if (viewSettings.showTransfers) {
            rowData["Transfers"] = row.transfers;
        }
        if (viewSettings.showIsBackup) {
            rowData["Is Backup"] = row.isBackup;
        }
        if (viewSettings.showIsForward) {
            rowData["Is Forward"] = row.isForward;
        }
        if (kpiResult) {
            rowData[`KPI <${kpiResult.kpiConfig.thresholds.excellent || 5}m`] =
                `${row.kpiExcellentPercent || "0%"} (${row.kpiExcellent || 0})`;
            rowData[`KPI <${kpiResult.kpiConfig.thresholds.good || 15}m`] =
                `${row.kpiGoodPercent || "0%"} (${row.kpiGood || 0})`;
            rowData[`KPI <${kpiResult.kpiConfig.thresholds.acceptable || 30}m`] =
                `${row.kpiAcceptablePercent || "0%"} (${row.kpiAcceptable || 0})`;
            rowData[`KPI >${kpiResult.kpiConfig.thresholds.acceptable || 30}m`] =
                `${row.kpiPoorPercent || "0%"} (${row.kpiPoor || 0})`;
        }
        return rowData;
    });
    await exportToExcelWithXLSX({
        filename: "Executive_Summary",
        data: exportData,
        sheetName: "Executive Summary",
    });
};
export const handleExecutiveSummaryPdfExport = () => {
    console.log("PDF export will be implemented with html2canvas + jsPDF");
};
//# sourceMappingURL=executiveSummaryExportUtils.js.map